function clickableCard(element, link) {

  element.addEventListener('click', (e) => {

    if (link.getAttribute('type') == 'application/pdf' || link.getAttribute('type') == 'video/mp4') {
      window.open(link, '_blank');
    } else {
      window.open(link, '_self');
    }

    if (e.target.type == 'application/pdf' || e.target.type == 'application/zip' || e.target.type == 'video/mp4') {
      e.preventDefault();
    }
  })

  element.style.cursor = 'pointer';
  element.classList.add('clickable');
}

const elements = document.querySelectorAll('.clickable-element');

if (!_.isEmpty(elements)) {
  Array.from(elements).forEach(teaser => {
    const link = teaser.getElementsByTagName('A')[0];

    if (! lodash.isNil(link)) {
      clickableCard(teaser, link);
    }
  });
}
